import { FC, PropsWithChildren } from 'react';
import { ConfigProvider } from 'antd';

export const SearchInputMainProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Select: {
              controlHeight: 55,
              fontFamily: 'Inter',
            },
          },
        }}
      >
        {children}
      </ConfigProvider>
    </>
  );
};
